/*
* product-related Vue component
* ---
* Related products retrieved via Product Recommendations Ajax API
* https://shopify.dev/docs/themes/ajax-api/reference/product-recommendations
*
* Example usage:
*
* <product-related inline-template product-id="{{ product.id }}"/>
*/

import axios from 'axios';
import ProductItem from './product-item.js';
import { transformAjaxProduct } from './../utils/data';

export default {
    components: {
        ProductItem
    },

    props: {
        productId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            isLoading: true,
            recommendedProducts: []
        }
    },

    async created() {
        const recommendedPromise =  this._getRecommendedProducts();
        await recommendedPromise.then(data => {
            this.recommendedProducts = data;
        }).catch(error => {
            console.log(error);
        });
        this.isLoading = false;
    },

    methods: {
        _getRecommendedProducts() {
            return axios.get(`/recommendations/products.json?product_id=${ this.productId }&limit=4`).then(({ data }) => {
                return data.products.map(product => transformAjaxProduct(product));
            }).catch((error) => {
                console.log('Recommended products', error);
                throw error;
            });
        }
    }
}